import { render, staticRenderFns } from "./M2hUpcomingEvents.vue?vue&type=template&id=256ee002&scoped=true&"
import script from "./M2hUpcomingEvents.vue?vue&type=script&lang=js&"
export * from "./M2hUpcomingEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256ee002",
  null
  
)

export default component.exports